export default __webpack_public_path__ + "static/media/festif.bcb71514.png";